import { useContext } from "react";
import { AppStateContext } from "../context/app-state-context";
import { usePatchableState } from "./use-patchable-state";
export function useAppState() {
  return usePatchableState(useContext(AppStateContext));
}
;